import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function BlogCard({ name, banner, img, slug, _ele }) {
  const [loaded, setLoaded] = useState(false);
  const href = `/blog/${slug?.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-') || ''}`;
  const thumb = banner || img;

  return (
    <article className="game-card-hover rounded-xl overflow-hidden card-sm">
      <Link to={href} className="block no-underline">
        <div className="relative w-full overflow-hidden bg-hover-theme aspect-[16/9]">
          {!loaded && <div className="absolute inset-0 skeleton" />}
          <img src={thumb} alt={name} loading="lazy" onLoad={() => setLoaded(true)}
            className={`w-full h-full object-cover transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'}`} />
          {_ele?.categories?.en?.[0] && (
            <span className="absolute top-2 left-2 text-white text-[10px] font-extrabold px-2 py-0.5 rounded uppercase bg-[rgba(79,142,247,0.9)] backdrop-blur-sm">
              {_ele.categories.en[0]}
            </span>
          )}
        </div>
        <div className="p-3">
          <h3 className="text-xs font-extrabold mb-1.5 line-clamp-2 text-main leading-snug">{name}</h3>
          {_ele?.description?.en && (
            <p className="text-[11px] mb-2 line-clamp-2 text-dim leading-relaxed">{_ele.description.en}</p>
          )}
          {_ele?.tags?.en?.length > 0 && (
            <div className="flex flex-wrap gap-1">
              {_ele.tags.en.slice(0, 3).map((tag, i) => (
                <span key={i} className="text-[10px] font-bold px-1.5 py-0.5 rounded text-accent-color bg-[rgba(79,142,247,0.1)]">
                  #{tag}
                </span>
              ))}
            </div>
          )}
        </div>
      </Link>
    </article>
  );
}

export default BlogCard;
